const teamMembers = [
  {
    name: { ar: "بدر محمد الصيوان", en: "Badr Mohammed Al-Saiwan" },
    title: {
      ar: "المدير العام – والمشرف على قسم التسويق العقاري",
      en: "General Manager – Head of Real Estate Marketing",
    },
    description: {
      ar: "يشرف على أنشطة التسويق العقاري، ويقود التوجهات الاستراتيجية لضمان تحقيق الأهداف وتعزيز حضور الشركة في السوق العقاري.",
      en: "Oversees real estate marketing, leads strategic directions to achieve objectives and enhance market presence.",
    },
    section: { ar: "الإشراف العام", en: "General Supervision" },
    image: "/images/badr.jpg",
  },
  {
    name: { ar: "محمود سمير القاسم", en: "Mahmoud Sameer Al-Qasim" },
    title: { ar: "مدير تقنية المعلومات (IT)", en: "IT Director" },
    description: {
      ar: "يدعم القسم من الناحية التقنية، ويشرف على تطوير الأنظمة الرقمية المستخدمة في تسويق العقارات وإدارة البيانات.",
      en: "Provides technical support and supervises the development of digital systems used in real estate marketing and data management.",
    },
    section: { ar: "القسم التقني", en: "Technical Department" },
    image: `${process.env.PUBLIC_URL}/#`,
  },
  {
    name: { ar: "خالد المطيري", en: "Khalid Al-Mutairi" },
    title: { ar: "مسؤول العقود العقارية", en: "Real Estate Contracts Officer" },
    description: {
      ar: "يتولى إعداد ومتابعة العقود العقارية، وضمان توافقها مع الأنظمة والسياسات المعتمدة.",
      en: "Responsible for drafting and managing real estate contracts, ensuring compliance with policies and regulations.",
    },
    section: { ar: "قسم العقود", en: "Contracts Department" },
    image: "/images/khalid.jpg",
  },
  {
    name: { ar: "سالم سعيد بامساطر", en: "Salem Saeed Bamsater" },
    title: { ar: "سكرتير تنفيذي", en: "Executive Secretary" },
    description: {
      ar: "يدير العمليات الإدارية داخل القسم، وينسق المواعيد والمراسلات والاجتماعات الرسمية.",
      en: "Manages administrative operations, coordinates appointments, communications, and official meetings.",
    },
    section: { ar: "السكرتارية", en: "Secretarial Department" },
    image: "/images/salem.jpg",
  },
  {
    name: { ar: "عبدالله السعيد", en: "Abdullah Al-Saeed" },
    title: {
      ar: "مسؤول التسويق العقاري – منطقة الرياض",
      en: "Real Estate Marketing Officer – Riyadh Region",
    },
    description: {
      ar: "يتولى تسويق العقارات في الرياض وبناء علاقات مع العملاء.",
      en: "Handles real estate marketing in Riyadh and builds client relationships.",
    },
    section: {
      ar: "قسم التسويق العقاري – الرياض",
      en: "Real Estate Marketing Department – Riyadh",
    },
    image: "/images/abdullah-riyadh.jpg",
  },
  {
    name: { ar: "فهد بكري", en: "Fahad Bakri" },
    title: {
      ar: "مسؤول التسويق العقاري – الخبر والدمام",
      en: "Real Estate Marketing Officer – Khobar & Dammam",
    },
    description: {
      ar: "يُعنى بتسويق الوحدات العقارية في المنطقة الشرقية، وبناء شبكة علاقات فعّالة مع العملاء والمستثمرين.",
      en: "Responsible for marketing properties in the Eastern Region, and building strong client and investor relations.",
    },
    section: {
      ar: "قسم التسويق العقاري – الشرقية",
      en: "Real Estate Marketing Department – Eastern Region",
    },
    image: "/images/fahad.jpg",
  },
  {
    name: { ar: "عبدالله عبدالمجيد", en: "Abdullah Abdulmajid" },
    title: {
      ar: "مسؤول الحملات الإعلانية العقارية",
      en: "Real Estate Advertising Campaigns Officer",
    },
    description: {
      ar: "مختص في إعداد وتنفيذ الحملات الإعلانية الرقمية، وتحليل أدائها لتعزيز الظهور العقاري وزيادة فرص البيع والتأجير.",
      en: "Specialist in designing and executing digital ad campaigns and analyzing their performance to increase real estate visibility and conversion.",
    },
    section: {
      ar: "قسم الحملات الإعلانية",
      en: "Advertising Campaigns Department",
    },
    image: "/images/abdullah-ads.jpg",
  },
  {
    name: { ar: "ناصر المعيقلي", en: "Nasser Al-Mueqli" },
    title: { ar: "مصور عقاري", en: "Real Estate Photographer" },
    description: {
      ar: "يتولى تصوير العقارات بجودة عالية لإبراز مزاياها على المنصات الإعلانية وتعزيز جاذبيتها لدى العملاء.",
      en: "Captures high-quality real estate photography to highlight property features and attract clients.",
    },
    section: {
      ar: "قسم التصوير العقاري",
      en: "Real Estate Photography Department",
    },
    image: "/images/nasser.jpg",
  },
  {
    name: { ar: "سارة آل شاكر", en: "Sarah Al-Shaker" },
    title: { ar: "مسؤولة خدمات العملاء", en: "Customer Service Officer" },
    description: {
      ar: "تتولى استقبال استفسارات العملاء ومتابعة طلباتهم، وضمان تجربة احترافية ومرضية في التعامل مع خدمات الشركة العقارية.",
      en: "Handles customer inquiries and requests, ensuring a professional and satisfying experience with the company’s real estate services.",
    },
    section: { ar: "قسم خدمات العملاء", en: "Customer Service Department" },
    image: "/images/sarah.jpg",
  },
];

export default teamMembers;
